import {
  formatter,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { getChartBufferWidth } from '@op/utils/systemUtil';
import React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'umi';

function getTableTitleText(title: string) {
  return `<span style="font-size: 12px">${title}</span>`;
}
const isEmpty = (val: string | undefined | number) => {
  return !val || val === '-';
};
export default function LineCharts({
  timeLine,
  dateType,
  title,
  scoreValueFormat,
}: any) {
  const { formatMessage } = useIntl();

  const initMentions = (): [any, boolean] => {
    let { x, score, reviews } = timeLine || { x: [], score: [], reviews: [] };
    let empty =
      x.length === 0 ||
      (score.every((item: number) => item === 0) &&
        reviews.every((item: number) => item === 0));
    if (empty) {
      return [[], empty];
    }

    const option = {
      backgroundColor: 'rgba(255,255,255,0)',
      xAxis: {
        show: false,
        type: 'category',
        data: x || [],
      },
      yAxis: {
        show: false,
        type: 'value',
        min: 0,
        max: 5,
      },
      grid: {
        left: getChartBufferWidth(5),
        top: 5,
        bottom: 5,
        right: 0,
        containLabel: false,
      },
      tooltip: {
        appendToBody: true,
        confine: false,
        formatter: (params: any) => {
          // 时间
          let dataTime = listTimeTitleFunc(params[0]?.axisValue, dateType);

          let tableData: { type: string; score: any }[] = [];
          params.forEach((item: any) => {
            let { reviews, value } = item.data || {};
            tableData.push({
              type: getTableTitleText(formatMessage({ id: title })),
              score: getTableTitleText(scoreValueFormat(value)),
            });
            tableData.push({
              type: getTableTitleText(formatMessage({ id: 'Reviews' })),
              score: getTableTitleText(reviewsFormat(reviews)),
            });
          });
          return formatter({
            title: dataTime,
            tables: [
              {
                showHeader: false,
                records: tableData,
                columns: [
                  {
                    key: 'type',
                  },
                  {
                    weight: 'bold',
                    align: 'right',
                    key: 'score',
                  },
                ],
              },
            ],
          });
        },
      },
      series: [
        {
          type: 'line',
          data: score?.map((d: string | undefined, index: number) => {
            return {
              value: d,
              reviews: reviews[index],
            };
          }),
          lineStyle: {
            width: 2,
            color: '#6E7794',
          },
          itemStyle: {
            width: 2,
            color: '#6E7794',
          },
        },
      ],
    };

    return [option, empty];
  };

  const [options, empty] = useMemo(() => {
    return initMentions();
  }, [timeLine, formatMessage]);

  return (
    <EChartCommon
      empty={empty}
      height={40}
      options={options}
      optionsProps={{
        type: 'line',
        excludeOptions: ['legend', 'axisPointer'],
      }}
      hasEmptyImg={false}
      hasEmptyDesc={false}
      hasEmptyTitle={false}
    ></EChartCommon>
  );
}
